import React, {Component} from 'react';
import Size from "./steps/Size";
import Collection from "./steps/Collection";
import Payment from "./steps/Payment";
import Loqateservice from './services/LoqateService';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import axios from "axios/index";
import HelpOurTeam from "./steps/HelpOurTeam";
import Loader from 'react-loader-spinner';
import BagJunk from "./steps/bagSteps/BagJunk";
import BagSize from "./steps/bagSteps/BagSize";
import BagConfirmation from "./steps/bagSteps/BagConfirmation";
import BuyBagsCollection from "./steps/BuyBagsCollection";
import BuyBagConfirmation from "./steps/bagSteps/BuyBagConfirmation";

class BagWizard extends Component {
    constructor(props) {
        super(props);

        this.Loqateservice = new Loqateservice();

        this.state = this.getStateFromLocalStorage();

        this.changeStep = this.changeStep.bind(this);
        this.updateState = this.updateState.bind(this);
        this.setValidity = this.setValidity.bind(this);
        this.updateOrderPrices = this.updateOrderPrices.bind(this);
        this.increment = this.increment.bind(this);
        this.decrement = this.decrement.bind(this);
        this.updateCollectionState = this.updateCollectionState.bind(this);
    }

    componentDidMount() {
        console.log(this.props);
        gtag('event', 'conversion', {'send_to': 'AW-703359936/z9AzCLmczM4BEMDXsc8C'});

        this.Loqateservice.getLocationId(this.state.postcode)
            .then(res => {
                let container = res.data.Items[0]['Id'];
                let postcode = this.state.postcode;
                return axios.post('/addresses', {postcode, container})
                    .then(res => {
                        this.setState({
                            availableAddresses: res.data.Items,
                            data: true
                        })
                    })
            });

    }

    increment(id) {
        //  Create fresh copy of "sizes" piece of state
        //  To avoid mutating state
        let clone = this.state.sizes.slice().map(item => {
            return {...item};
        });

        //  Modify cloned variable
        let items = clone.map(item => {
            if (item.id === id) {
                if (item.quantity >= 0) {
                    item.quantity += 1;
                }
            }
            return item;
        });

        //  Set state
        this.setState({sizes: items});
    }

    decrement(id) {
        //  Create fresh copy of "sizes" piece of state
        //  To avoid mutating state
        let clone = this.state.sizes.slice().map(item => {
            return {...item};
        });

        //  Modify cloned variable
        let items = clone.map(item => {
            if (item.id === id) {
                if (item.quantity > 0) {
                    item.quantity -= 1;
                }
            }
            return item;
        });

        //  Set state
        this.setState({sizes: items});
    }

    updateState(pieceOfState, newPieceOfState) {
        let newState = Object.assign({}, this.state);
        newState[pieceOfState] = newPieceOfState;
        this.setState(newState);
    }

    updateCollectionState(value) {
        this.setState({collectionState: {...this.state.collectionState, ...value}})
    }

    updateOrderPrices() {
        //  Calculate junk bags price
        let junk = 0;
        //  Map over all bag sizes
        this.state.junkState.size.map(obj => {
            //  Check for quantity selected
            if (obj.quantity > 0) {
                //  Multiply price with quantity and add to "junk" variable
                return junk += obj.price * obj.quantity;
            }
        });


        // todo: this needs rework
        // let extras = this.state.sizeState.extras.filter((extra) => extra.qty).length
        //     ? this.state.sizeState.extras.filter((extra) => extra.qty).map(extra => extra.total_price*100).reduce((prev, next) => prev + next)
        //     : 0;
        let extras = 0;

        if (this.state.sizeState.selected_extras.length > 0) {
            let selected = [...this.state.sizeState.selected_extras];
            extras = selected.map(extra => extra.total_price * 100).reduce((prev, next) => prev + next);
        }

        let next_day = this.state.helpState.arrival.type == 'next_day' ? 1000 : 0;
        this.setState({
            order_total: (+junk) + (+extras) + (+next_day)
        }, () => {
            let updateCartEvent = new CustomEvent('updateCart', {'detail': this.state.order_total});
            document.dispatchEvent(updateCartEvent);
        });

    }

    setValidity(step, value) {
        let steps = this.state.steps;
        steps[step].valid = value;
        this.setState({steps});
    }

    changeStep(index) {
        if (index <= 0) {
            this.setState({
                currentStep: 0,
                validationError: null
            }, () => {
                scrollToComponent(this.wizardStart, {offset: 0, align: 'top', duration: 20, ease: 'inExpo'});
            });
        } else if (index > 0 && this.state.steps[index - 1].valid) {
            this.setState({
                currentStep: index,
                validationError: null
            }, () => {
                sessionStorage.setItem('wizardState', JSON.stringify(this.state));
                scrollToComponent(this.wizardStart, {offset: 0, align: 'top', duration: 20, ease: 'inExpo'});
            });
        } else {
            this.setState({validationError: "Please fill all fields on this page to proceed"})
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.data &&
                <section ref={(section) => {
                    this.wizardStart = section;
                }}>
                    <section id="stepper" className='d-none d-sm-block'>
                        <div className="container pt-5">
                            <div className="row justify-content-center mb-3">
                                <h2 className="wizard-heading">Steps</h2>
                            </div>
                            <div className="row">
                                <ul className="nav nav-wizard">
                                    {this.state.steps.map((step, index) => {
                                        let stepClassName = this.state.currentStep === index ? "active" : "";
                                        return (
                                            <li key={index}
                                                className={stepClassName}
                                                onClick={() => this.changeStep(index)}
                                            >

                                                <a role="button" style={{textTransform: 'uppercase', letterSpacing: '1px'}}><span
                                                    className="wizard-number" style={{color: '#514f4c', paddingTop: '5px', fontSize: '150%', fontWeight: '600'}}>{(index + 1)}</span><span style={{paddingTop: '15px', color: '#514f4c', fontWeight: '600'}}>{step.title}</span></a>
                                            </li>);
                                    })}
                                </ul>
                            </div>
                        </div>
                    </section>

                    {this.state.currentStep === 0 &&
                    <BagJunk
                        headerTitle='Choose bags'
                        globalStateChange={(param) => this.updateState('junkState', param)}
                        updatePrice={() => this.updateOrderPrices()}
                        buyBags
                        localState={this.state.junkState}
                        bagQty={this.state.bagQty}
                        sizes={this.state.sizes}
                        increment={this.increment}
                        decrement={this.decrement}
                        setValidity={(value) => this.setValidity(0, value)}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}
                    />
                    }

                    {this.state.currentStep === 1 &&
                    <BagSize
                        noAddExtras
                        globalStateChange={(param) => this.updateState('sizeState', param)}
                        localState={this.state.sizeState}
                        size={this.state.junkState}
                        updatePrice={() => this.updateOrderPrices()}
                        types={this.state.junkTypes}
                        extras={this.state.extras}
                        setValidity={(value) => this.setValidity(1, value)}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                    />
                    }

                    {this.state.currentStep === 2 &&
                    <BuyBagsCollection
                        globalStateChange={(param) => this.updateState('collectionState', param)}
                        localState={this.state.collectionState}
                        availableAddresses={this.state.collectionState.available_addresses}
                        updateCollectionState={this.updateCollectionState}
                        cut_off={this.props.cut_off}
                        setValidity={(value) => this.setValidity(2, value)}
                        arrivals={this.props.arrivals}
                        postcode={this.state.postcode}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                    />
                    }

                    {this.state.currentStep === 3 &&
                    <BuyBagConfirmation
                        globalStateChange={(param) => this.updateState('confirmationState', param)}
                        localState={this.state.confirmationState}
                        junk={this.state.junkState}
                        size={this.state.sizeState}
                        collection={this.state.collectionState}
                        help={this.state.helpState}
                        setValidity={(value) => this.setValidity(3, value)}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                    />
                    }

                    {this.state.currentStep === 4 &&
                    <Payment
                        globalStateChange={(param) => this.updateState('companyNumberState', param)}
                        stripe_key={this.props.stripe_key}
                        localState={this.state}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                        paymentError={this.props.paymentError}
                        variation="buy-bags"
                    />
                    }
                </section>
                }

                {!this.state.data &&
                <div className="container" style={{height: '80vh', position: 'relative'}}>
                    <div className="row" style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
                        <div className="col-12 justify-content-center">
                            <Loader type="Oval" color="#514f4c" height={50} width={50}/>
                        </div>
                    </div>
                </div>
                }
            </React.Fragment>
        );
    }

    getDefaultState() {
        //  add "quantity" property to all bag types
        let qty = this.props.sizes.slice().map(size => {
            return {...size, quantity: 0};
        });
        return {
            data: false,
            order_total: 0,
            sizes: qty,
            junkTypes: this.props.junkTypes,
            // extras: this.props.extras,
            postcode: this.props.postcode,
            availableAddresses: {},
            validationError: '',
            currentStep: 0,
            // bagQty: qty,
            junkState: {
                size: ''
            },
            sizeState: {
                type: '',
                extras: this.props.extras,
                selected_extras: []
            },
            collectionState: {
                address_find: '',
                available_addresses: [],
                selectedPostcode: '',
            },
            helpState: {
                arrival: '',
                access: true,
                parking: true
            },
            confirmationState: {
                totalPrice: '',
                address: '',
                coupon: '',
                appliedCoupon: ''
            },
            steps: [
                {
                    title: 'Size',
                    valid: false,
                },
                {
                    title: 'Extras',
                    valid: true,
                },
                {
                    title: 'Details',
                    valid: false,
                },
                {
                    title: 'Summary',
                    valid: false,
                },
                {
                    title: 'Payment',
                    valid: false,
                }
            ],
        }
    }

    getStateFromLocalStorage() {
        let state = this.getDefaultState();

        let sessionStorageState = sessionStorage.getItem('wizardState');

        // read state from cookie and parse props here
        if (sessionStorage['wizardState']) {
            sessionStorageState = JSON.parse(sessionStorageState);
            return sessionStorageState;
        }

        return state;
    }
}

if (document.getElementById('buyBagWizard')) {
    let element = document.getElementById('buyBagWizard');
    ReactDOM.render(<BagWizard
        sizes={JSON.parse(element.dataset.sizes)}
        junkTypes={JSON.parse(element.dataset.types)}
        extras={JSON.parse(element.dataset.extras)}
        arrivals={JSON.parse(element.dataset.arrivals)}
        postcode={element.dataset.postcode}
        stripe_key={element.dataset.stripe_key}
        cut_off={element.dataset.cut_off}
        paymentError={element.dataset.payment_error}
    />, element);
}

export default BagWizard;
